<template>
  <el-container>
    <el-header>
      <Navigation></Navigation>
    </el-header>
    <el-main>
      <!-- <transition name="el-fade-in-linear"> -->
      <router-view />
      <!-- </transition> -->
    </el-main>
    <div>
      <ContactForm />
      <Footer />
    </div>
  </el-container>
</template>
<script>
import Navigation from '@/components/Navigation.vue';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';

export default {
  components: {
    Navigation,
    ContactForm,
    Footer,
  },
};
</script>
<style lang="scss" scoped>
.el-main {
  padding: 0;
}
</style>
